export const mainNum = 10
export const DEFAULT_COLOUR_ID = '0000000000'
export const SPEC_VALUE_MAX_LENGTH_NUM = 50

/**
 * 产品名称 标品
 */
export const SPU_TYPE_PRODUCE_NAME = 8
/**
 * 型号 标品
 */
export const SPU_TYPE_MODEL_NUMBER = 3

// 重置规格图
export const RESET_DISPLAY_IMAGES = 999

/** 铺货模板 AI 打标字段（值与 templatePropId / aiFullItemId 一致，行尾为中文说明） */
export const SHELF_TEMPLATE_MAP = {
    SKU_STOCK: 'SKU_STOCK', // 库存
    SKU_PRICE: 'SKU_PRICE', // 价格
    PACK_LISTING: 'PACK_LISTING', // 包装清单
    AFTER_SALE_DESCRIPTION: 'AFTER_SALE_DESCRIPTION', // 售后服务
    SHELVES_TYPE: 'SHELVES_TYPE', // 上架设置
}
